import { Box, Form, ModBox, Text } from '@jfs/ui-new'
import { profileDetails } from './formData'
const FormBox = ({ children }: any) => {
  return <Box>{children}</Box>
}
const ProfileDetails = () => {
  return (
    <Box f={1} overflow={'auto'} ph={40} pv={40}>
      <Text title={'Profile Details'} color={'BLACK_21'} fontSize={18} fontFamily={'jiotype-bold'} />
      <ModBox>
        <Form formData={profileDetails()} actionButtons={() => <></>} initialValues={{}} container={FormBox} />
      </ModBox>
    </Box>
  )
}

export { ProfileDetails }
